var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39426 14.5226C9.63344 13.4527 13.3237 9.98829 13.3237 6.66183C13.3237 5.24828 12.7621 3.89263 11.7626 2.89309C10.7631 1.89356 9.40741 1.33203 7.99386 1.33203C6.58031 1.33203 5.22466 1.89356 4.22512 2.89309C3.22559 3.89263 2.66406 5.24828 2.66406 6.66183C2.66406 9.98829 6.35428 13.4527 7.59346 14.5226C7.7089 14.6094 7.84943 14.6564 7.99386 14.6564C8.1383 14.6564 8.27882 14.6094 8.39426 14.5226Z",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99477 8.66141C9.09861 8.66141 9.99344 7.76658 9.99344 6.66274C9.99344 5.5589 9.09861 4.66406 7.99477 4.66406C6.89093 4.66406 5.99609 5.5589 5.99609 6.66274C5.99609 7.76658 6.89093 8.66141 7.99477 8.66141Z",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation3);
export default __webpack_public_path__ + "static/media/location3.c2d2258da7adfd078d11a9e859f26432.svg";
export { ForwardRef as ReactComponent };